<template>
    <div
        class="gcmcn-card"
        :class="{
            'selected-element' : selectedFeedResource === feedResource,
        }"

        @click="selectFeedResource"
    >
        <div class="card-body">
            <div class="card-info">
                <span class="stream-name">{{ feedResource.display_name }}</span>
                <span class="status">{{ feedResource.status }}</span>
            </div>
            <div>{{ entity.display_name }} | {{ universe.display_name }}</div>
        </div>
        <i
            class="el-icon-arrow-right selection-arrow"
            :class="{
                'rotate-icon-arrow' :selectedFeedResource === feedResource
            }"
        ></i>
    </div>
</template>

<script>
import {mapGetters} from 'vuex';
export default {

    name: 'feedResourceCard',
    props:{
        feedResource:{
            type:  Object,
            required: true,
        },
        selectedFeedResource:{
            type:  Object,
            required: false,
            default: ()=>{return null;}
        },
        universes: {
            type: Array,
            required: true,
        },
    },
    data () {
        return {

        };
    },
    computed:{
        ...mapGetters([
            'entitiesByUid',
        ]),
        entity(){
            if(this.feedResource){
                return this.entitiesByUid(this.feedResource.scopes.entity_uid);
            }
            return '';
        },
        universe(){
            if(this.feedResource){
                return this.universes.find(
                    (universe) => this.feedResource.universe_uid === universe.uid
                );
            }
            return '';
        }
    },
    methods:{
        selectFeedResource(){
            this.$emit('select-feed-resource', this.feedResource);
        }
    }
};
</script>

<style lang="scss">
    .gcmcn-card{
        margin-bottom: 2rem;
        position: relative;
        .card-body{
            display: flex;
            flex-direction: column;
            justify-content: center;
            font-family: "roboto-light";
            text-transform: uppercase;
            .card-info{
                display: flex;
                justify-content: space-between;
                font-size: 12px;
                line-height: 12px;
                font-family: "roboto";
                .stream-name{
                    font-weight: bold;
                    margin-bottom: 1rem;
                    flex-grow: 1;
                    color: #BBBBBB;
                }
                .status{
                    font-size: 9px;
                    font-weight: bold;
                    margin-right: 0.5rem;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/page/FeedResources/feed-resource-card.vue